export default "__VITE_ASSET__CxNtMDZx__"